import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {ColumnFiltersState} from "@tanstack/react-table";

interface BoxState {
    elements: Box1[],
    filter: {
        [
            key: string]: any
    }
    currentPage: number,
    rowsPerPage: number,
    totalRows: number,
    sort: string[],
    loading: boolean
}

interface Shed {
    _id: string,
    name: string
}

interface Dog {
    _id: string,
    name: string,
    microchipCode: string

}

export interface Box1 {
    _id:string,
    name:string,
    shedName: string
}



export interface BoxElement {
    shedName: any;
    _id: string,
    name: string,
    maxCapacity: number,
    dogIntoBox: number,
    isMaintenance: boolean,
    isAvailable: boolean,
    addDogId: Dog[] | [];
    shedId: Shed | null
}

export interface BoxAudit {

    action: string;
    oldValue: object;
    newValue: object;
    timestamp: string;
    username: string;

}

interface PageableDto {
    page: number;
    size: number;
    sort: string[];
}

export interface GetAllElementPayloadBox {
    pageableDto: PageableDto;
    filters: ColumnFiltersState | null
}

const initialState: BoxState = {
    elements: [],
    filter: {},
    currentPage: 0,
    rowsPerPage: 10,
    totalRows: 0,
    sort: ['dateCreated', 'asc'],
    loading: false
}

export interface BoxElementPayload {
    shedName: any | null;
    _id: string;
    name: string;
    maxCapacity: number;
    dogIntoBox: number;
    isMaintenance: boolean;
    isAvailable: boolean;
    shedId: string | null;
    addDogId: string[];
}

export const Box = createSlice(
    {
        name: "box",
        initialState,
        reducers: {

            getAllElementBox: (state, action: PayloadAction<GetAllElementPayloadBox>) => {
                state.loading = true;
            },
            getAllElementSuccess: (state, action: PayloadAction<{ data: BoxElement[], currentPage: number, totalRows: number }>) => {
                state.elements = action.payload.data;
                state.currentPage = action.payload.currentPage;
                state.totalRows = action.payload.totalRows;
                state.loading = false;
            },
            getAllElementError: (state) => {
                state.loading = false;
            },

            setPage: (state, action: PayloadAction<number>) => {
                state.currentPage = action.payload;
            },
            setRowsPerPage: (state, action: PayloadAction<number>) => {
                state.rowsPerPage = action.payload;
            },
            setSort: (state, action: PayloadAction<string[]>) => {
                state.sort = action.payload;
            },

            getAllElementBoxNotPageable: (state) => {
            },
            getAllElementSuccessBoxNotPageable: (state, action: PayloadAction<Box1[]>) => {
                state.elements = action.payload;
            },
            getAllElementErrorBoxNotPageable: (state) => {
                state.loading = false;
            },

            saveElement: (state, action: PayloadAction<{ box: BoxElement , callback: () => void }>) => {
                state.loading = true;
            },

            saveElementSuccess: (state, action: PayloadAction<BoxElement>) => {
                const newElement: BoxElement = {
                    ...action.payload,
                    shedId: action.payload.shedId
                        ? {_id: action.payload.shedId._id, name: action.payload.shedId.name}
                        : null,
                    addDogId: action.payload.addDogId.map((dog) => ({
                        _id: dog._id,
                        name: dog.name,
                        microchipCode: dog.microchipCode,
                    }))
                };
                state.elements.push(newElement);
            },
            saveElementError: (state, action: PayloadAction<BoxElement>) => {
                state.loading = false;
            },

            updateElement: (state, actions: PayloadAction<{ box: BoxElement , callback: () => void  }>) => {
                state.loading = true;

            },

            updateElementSuccess: (state, action: PayloadAction<BoxElement>) => {
                const index = state.elements.findIndex(
                    (element) => element._id === action.payload._id
                );
                if (index !== -1) {

                    const updatedElement: BoxElement = {
                        ...action.payload,
                        shedId: action.payload.shedId
                            ? {_id: action.payload.shedId._id, name: action.payload.shedId.name}
                            : null,
                        addDogId: action.payload.addDogId.map((dog) => ({
                            _id: dog._id,
                            name: dog.name,
                            microchipCode: dog.microchipCode,
                        }))
                    };

                    state.elements[index] = updatedElement;
                }
            },

            updateElementError: (state, action: PayloadAction<BoxElement>) => {
                state.loading = false;
            },

            deleteElement: (state, action: PayloadAction<{ id: string, callback: () => void }>) => {
            },
            deleteElementSuccess: (state, action: PayloadAction<string>) => {
            },
            deleteElementError: (state) => {
                state.loading = false;
            },

            boxAction: (state, action: PayloadAction<string>) => {
                state.loading = true;
            },
            boxActionSuccess: (state, action:PayloadAction<BoxElement[]>) => {
                state.loading = false;
            },
            boxActionError: (state) => {
                state.loading = false;
            },
        }
    }
)
export const {
    getAllElementBox,
    getAllElementSuccess,
    getAllElementError,
    getAllElementBoxNotPageable,
    getAllElementSuccessBoxNotPageable,
    getAllElementErrorBoxNotPageable,
    saveElement,
    saveElementSuccess,
    saveElementError,
    updateElement,
    updateElementSuccess,
    updateElementError,
    deleteElement,
    deleteElementSuccess,
    deleteElementError,
    setRowsPerPage,
    setSort,
    setPage,
    boxActionError,
    boxActionSuccess,
    boxAction
} = Box.actions

export default Box.reducer


